import useImperativeBaseFetch from "../../internal/fetch/useImperativeBaseFetch";
/**
 * **Using imperative fetching is discouraged! Keep reading to understand when
 * it's ok to use.**
 *
 * Returns an imperative fetching method that, when called, will return a
 * `Promise` that will resolve to the data. This method is similar to how the
 * native `fetch` operates, but it is contextualized to the current SDK options
 * and also generates telemetry automatically.
 *
 * To fetch data that is returned as text you can use `useImperativeTextFetch`
 * instead.
 *
 * Using imperative fetching in general is not adviceable. This is due to the
 * fact that React cannot update the result of a promise if the passed-in data
 * changes (e.g. if you update the URL or pass a new body) and depending on
 * `useJsonFetch` is better instead. Imperative fetches can't also be executed
 * while performing SSR.
 *
 * You can however rely on `useImperativeJsonFetch` if the result of the
 * request is disconnected from UI updates - in other words, the request could
 * be understood as a "fire and forget". This happens for instance for tracking
 * metrics or giving the user the ability to execute raw HTTP queries.
 */ export default function useImperativeJsonFetch() {
    return useImperativeBaseFetch('json');
}

//# sourceMappingURL=useImperativeJsonFetch.js.map